import { gql } from '@apollo/client';

const ADD_LEGAL_DOCUMENT = gql`
  mutation AddLegalDocument($orgId: Int!, $legalDocument: LegalDocumentInput!) {
    addLegalDocument(orgId: $orgId, legalDocument: $legalDocument)
  }
`;

export default ADD_LEGAL_DOCUMENT;
